import axios from "axios";

const {
    REACT_APP_BASE_URL,
    REACT_APP_FUNCTION_KEY,
} = process.env;

const SharedService = {
    /*
     [RG] Post
    */
    post: async ({token, url, data, params}) => {
        try {
            const response = await axios.post(`${REACT_APP_BASE_URL}/${url}`,
                   data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error posting data to the endpoint(${url}):`, error);
            throw error;
        }
    },
    /*
    [RG] GET
   */
    get: async ({token, url, params = {}}) => {
        try {
            const response = await axios.get(`${REACT_APP_BASE_URL}/${url}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error fetching data from the endpoint(${url}):`, error);
            throw error;
        }
    },
    /*
     [RG] PATCH
    */
    patch: async ({token, url, data, params}) => {
        try {
            const response = await axios.patch(`${REACT_APP_BASE_URL}/${url}`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error patching data to the endpoint(${url}):`, error);
            throw error;
        }
    },
    /*
     [RG] PUT
    */
    put: async ({token, url, data, params}) => {
        try {
            const response = await axios.put(`${REACT_APP_BASE_URL}/${url}`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error putting data to the endpoint(${url}):`, error);
            throw error;
        }
    },
    /*
    [RG] DELETE
    */
    delete: async ({token, url, params, data}) => {
        try {
            const response = await axios.delete(`${REACT_APP_BASE_URL}/${url}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                    data: data,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error delete data to the endpoint(${url}):`, error);
            throw error;
        }
    },
};

export default SharedService;